/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M0 1.75C0 .7835.7835 0 1.75 0h14c.9665 0 1.75.7835 1.75 1.75v6.6367c1.809 1.2109 3 3.273 3 5.6133 0 1.5903-.55 3.0522-1.4701 4.2058l4.4859 4.2497a.7501.7501 0 0 1-1.0316 1.089l-4.5138-4.2763a6.75 6.75 0 0 1-.4704.3451V22.25c0 .9665-.7835 1.75-1.75 1.75h-14C.7835 24 0 23.2165 0 22.25V1.75Zm16 0v5.884a6.7395 6.7395 0 0 0-2.25-.384c-1.8869 0-3.5929.7742-4.8178 2.0223A.7513.7513 0 0 0 8.75 9.25h-4a.75.75 0 0 0 0 1.5h3.0825C7.3019 11.7141 7 12.8218 7 14c0 .0837.0015.167.0045.25H4.75a.75.75 0 0 0 0 1.5h2.479c.7709 2.8796 3.3983 5 6.521 5a6.738 6.738 0 0 0 2.25-.3841V22.25a.25.25 0 0 1-.25.25h-14a.25.25 0 0 1-.25-.25V1.75a.25.25 0 0 1 .25-.25h14a.25.25 0 0 1 .25.25ZM4 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8A.75.75 0 0 1 4 5Zm13.5303 7.5303a.75.75 0 0 0 0-1.0606.75.75 0 0 0-1.0606 0L13 14.9393l-1.4697-1.4696a.75.75 0 0 0-1.0606 0 .75.75 0 0 0 0 1.0606l1.9646 1.9647a.8.8 0 0 0 1.1314 0l3.9646-3.9647Z"
    clipRule="evenodd"
  />,
  'MenuAuditLogsFilled'
);
